<template>
  <div>
    <LayoutTelaFiltros
      :titulo="this.$route.meta.titulo"
      :registros="listaEntradas"
      :camposTabela="retornaCamposTabela()"
      :camposMascaraData="['dataEntrada']"
      ordenarPor="codigo"
      :totalPaginas="totalDePaginas"
      :isLoading="isLoading"
      @buscarTodos="buscarTodos"
      @buscaFiltro="buscaFiltro"
      @limpar="limpar"
    />

    <fab
      :position="floatButton.position"
      :bg-color="floatButton.bgColor"
      :fixed-tooltip="true"
      :actions="floatButton.fabActions"
      :start-opened="true"
      @cadastroEntradas="cadastroEntradas" />
  </div>
</template>

<script>
import fab from 'vue-fab'
import LayoutTelaFiltros from '@/components/layouts/LayoutTelaFiltros.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'

import Entradaservice from '../../services/entradas.service'

const botaoFlutuante = {
  bgColor: '#003149',
  position: 'bottom-right',
  fabActions: [
    {
      name: 'cadastroEntradas',
      icon: 'person_add',
      tooltip: 'Cadastrar Entradas',
    },
  ],
}

export default {
  name: 'Entradas',
  components: {
    LayoutTelaFiltros,
    fab,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      listaEntradas: [],
      totalDePaginas: 0,
      floatButton: botaoFlutuante,
      isLoading: false,
    }
  },
  created() {
    this.buscarTodos()
  },
  methods: {
    async buscarTodos(pagina = 0) {
      this.mostrarLoader()
      try {
        const Entradas = await Entradaservice.retornaTodos(pagina)
        this.listaEntradas = Entradas.lista
        this.totalDePaginas = Entradas.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    async buscaFiltro(filtro, pagina = 0) {
      this.mostrarLoader()
      try {
        const Entradas = await Entradaservice.retornaTodosPorFiltro(filtro, pagina)
        this.listaEntradas = Entradas.lista
        this.totalDePaginas = Entradas.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    clicouItemTabela(item) {
      this.$router.push({
        name: 'rota-entradas-alteracao',
        params: { id: item._id },
      })
    },
    limpar() {
      this.listaEntradas = []
      this.totalPaginas = 0
    },
    retornaCamposTabela() {
      return {
        'filial.codigo': {
          label: 'Filial',
        },
        'produto.codigo': {
          label: 'Código produto',
        },
        'produto.nome': {
          label: 'Nome produto',
        },
        quantidade: {
          label: 'Quantidade',
        },
        'usuarioEntrada.usuario': {
          label: 'Usuario',
        },
        dataEntrada: {
          label: 'Data da entrada',
        },
      }
    },
    cadastroEntradas() {
      this.$router.push({ name: 'rota-entradas-cadastro' })
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}

</script>
